import React from 'react';

function Underline({ size }) {
  return (
    <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9998 18.3333C10.5858 18.3317 9.2302 17.7693 8.23035 16.7695C7.2305 15.7696 6.66809 14.414 6.6665 13V5H7.99984V13C7.99984 14.0609 8.42126 15.0783 9.17141 15.8284C9.92155 16.5786 10.939 17 11.9998 17C13.0607 17 14.0781 16.5786 14.8283 15.8284C15.5784 15.0783 15.9998 14.0609 15.9998 13V5H17.3332V13C17.3316 14.414 16.7692 15.7696 15.7693 16.7695C14.7695 17.7693 13.4138 18.3317 11.9998 18.3333V18.3333Z"
        fill="black"
      />
      <path d="M20 19.6667H4V21.0001H20V19.6667Z" fill="black" />
    </svg>
  );
}

export default Underline;
